import { createHttpEndpoint } from '../../utils'

import type {
  GetShippingMethods,
  GetShippingMethodsMetadata,
} from './shipping-methods.types'

/**
 * Retrieve shipping methods as an authenticated merchant.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Shipping-methods/operation/get-bm-merchants-shipping-methods}
 */
export const getShippingMethods = createHttpEndpoint<GetShippingMethods>({
  method: 'GET',
  operationId: 'getMerchantShippingMethods',
  path: '/bm/merchants/shipping-methods',
})

/**
 * Retrieve shipping methods metadata as an authenticated merchant.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Shipping-methods/operation/get-bm-merchants-shipping-methods-metadata}
 */
export const getShippingMethodsMetadata =
  createHttpEndpoint<GetShippingMethodsMetadata>({
    method: 'GET',
    operationId: 'getMerchantShippingMethodsMetaData',
    path: '/bm/merchants/shipping-methods/metadata',
  })

/**
 * Create a global shipping method as an authenticated merchant.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Shipping-methods/operation/post-bm-merchants-shipping-methods-global}
 */
export const postShippingMethod = createHttpEndpoint({
  method: 'POST',
  operationId: 'createMerchantShippingMethod',
  path: '/bm/merchants/shipping-methods/:categoryType',
})

/**
 * TODO Add link to API specs when available
 */
export const patchShippingMethod = createHttpEndpoint({
  method: 'PATCH',
  operationId: 'editMerchantShippingMethod',
  path: '/bm/merchants/shipping-methods/:categoryType/:shippingMethodId',
})

/**
 * TODO Add link to API specs when available
 */
export const deleteShippingMethod = createHttpEndpoint({
  method: 'DELETE',
  operationId: 'deleteMerchantShippingMethod',
  path: '/bm/merchants/shipping-methods/:categoryType/:shippingMethodId',
})
